export default function sendMail (body) {
  return $app.axios.post('/emails', body)
}